import { render, staticRenderFns } from "./TrainingRecordsTable.vue?vue&type=template&id=87b97d02"
import script from "./TrainingRecordsTable.js?vue&type=script&lang=js&external"
export * from "./TrainingRecordsTable.js?vue&type=script&lang=js&external"
import style0 from "./TrainingRecordsTable.vue?vue&type=style&index=0&id=87b97d02&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/data/jenkins/jenkins_workspace/workspace/vuejs-tb-train-ontraining-web-sim/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('87b97d02')) {
      api.createRecord('87b97d02', component.options)
    } else {
      api.reload('87b97d02', component.options)
    }
    module.hot.accept("./TrainingRecordsTable.vue?vue&type=template&id=87b97d02", function () {
      api.rerender('87b97d02', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/training-records/training-records-table/TrainingRecordsTable.vue"
export default component.exports